export default __webpack_public_path__ + "static/media/login-tilte-mobile-cn.fc61c95b.svg";